/* global google */
import React from 'react'
import { Marker, InfoWindow } from 'react-google-maps'
// import { InfoBox } from 'react-google-maps/lib/components/addons/InfoBox'
import { PinpointDetailProject } from 'assets/images/icon'
import { RedMapPin } from 'assets/images/web-isn';
// import { Close } from 'assets/images/web-isn';
import { useHistory } from 'react-router';

const MarkerIcon = (props) => {

  const history = useHistory();
  const language = localStorage.getItem('language');

  const goDetailProject = e => {
    e.preventDefault();
    history.push(`/${language}/featured-projects/detail/overview/${props.marker.projectId}/${props.marker.slug}?home=true`);
  };

  return (
    // { marker}
    <>
      {props.marker ? (
        <Marker key={props.marker.id}
          icon={{
            url: PinpointDetailProject,
            size: new google.maps.Size(48, 57),
            // condition: props.lac.condition,
          }}
          defaultPosition={{ lat: props.marker.latitude, lng: props.marker.longitude }}
          onClick={() => { props.onToggleOpen(props.marker.projectId) }}
        >
          {props.isOpen === props.marker.projectId && <InfoWindow key={props.marker.projectId} onCloseClick={props.onToggleOpen(props.marker.projectId)}>
            <div className="box-tooltip-map-detail">
              {/* <div onClick={() => props.onToggleClose()} className="btn-close-tooltip">
                <img alt="" src={Close} />
              </div> */}
              <img onClick={goDetailProject} className="w-100" src={`${process.env.REACT_APP_ISN_IMAGE_URL}${props.marker.imageUrl}`} alt="" />
              <div>
                <div onClick={goDetailProject}>
                  <h3>{props.marker.projectName}</h3>
                </div>
                <div onClick={goDetailProject} className="d-flex mt-2 align-items-center location-address">
                  <img className="mr-1 width-fit-content" src={RedMapPin} alt="location" />
                  <span className="mr-3 font-noto-sans-jp text-truncate-address">
                    {/* {t('search_property.address')} */}
                    {props.marker.address}
                  </span>
                </div>
              </div>
            </div>
          </InfoWindow>}
        </Marker>
      ) : ''}
    </>
  )
}

// const mapDispatchToProps = dispatch => ({
//   handleClick: lac => dispatch(ActionCreators.setPerimeterSelectedLac(lac))
// })

export default MarkerIcon
